import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "detail-wage-board__layout common-wage-detail-board" }
const _hoisted_2 = { class: "detail-wage-board__row" }
const _hoisted_3 = { class: "wage-detail-card wage-detail-card--pay-hourly" }
const _hoisted_4 = { class: "wage-detail-card__head" }
const _hoisted_5 = { class: "wage-detail-card__head-text" }
const _hoisted_6 = { class: "wage-detail-card__title wage-detail-card__title--with-help" }
const _hoisted_7 = { style: {"white-space":"pre-line"} }
const _hoisted_8 = {
  key: 0,
  class: "wage-detail-card__head-actions"
}
const _hoisted_9 = {
  class: "wage-basic-calc-mode",
  role: "group",
  "aria-label": "기본급 산출 방식"
}
const _hoisted_10 = ["disabled"]
const _hoisted_11 = ["disabled"]
const _hoisted_12 = { class: "wage-detail-card__body wage-detail-card__body--stretch" }
const _hoisted_13 = { class: "wage-detail-card__content" }
const _hoisted_14 = { class: "wage-payroll-grid wage-payroll-grid--work" }
const _hoisted_15 = { style: {"white-space":"pre-line"} }
const _hoisted_16 = ["value", "disabled"]
const _hoisted_17 = { style: {"white-space":"pre-line"} }
const _hoisted_18 = ["value", "disabled"]
const _hoisted_19 = { class: "wage-payroll-grid wage-payroll-grid--hourly-linked" }
const _hoisted_20 = ["value", "disabled"]
const _hoisted_21 = ["for"]
const _hoisted_22 = { style: {"white-space":"pre-line"} }
const _hoisted_23 = ["for"]
const _hoisted_24 = {
  key: 2,
  class: "wage-payroll-premium"
}
const _hoisted_25 = ["id", "value", "disabled", "onInput", "onBlur"]
const _hoisted_26 = ["title"]
const _hoisted_27 = ["id", "value", "disabled", "onInput", "onBlur"]
const _hoisted_28 = ["title"]
const _hoisted_29 = {
  key: 4,
  class: "wage-payroll-grid__input wage-payroll-grid__input--readonly"
}
const _hoisted_30 = ["value", "disabled", "onInput", "onBlur"]
const _hoisted_31 = { class: "wage-detail-card__footer" }
const _hoisted_32 = { class: "wage-card-total" }
const _hoisted_33 = { class: "wage-card-total__value" }
const _hoisted_34 = { class: "wage-detail-card wage-detail-card--nonTax" }
const _hoisted_35 = { class: "wage-detail-card__body wage-detail-card__body--stretch" }
const _hoisted_36 = { class: "wage-detail-card__content" }
const _hoisted_37 = { class: "wage-payroll-grid" }
const _hoisted_38 = ["for"]
const _hoisted_39 = { style: {"white-space":"pre-line"} }
const _hoisted_40 = ["for"]
const _hoisted_41 = ["id", "value", "disabled", "onInput"]
const _hoisted_42 = {
  key: 0,
  class: "wage-payroll-grid wage-payroll-grid--hourly-linked"
}
const _hoisted_43 = { class: "wage-payroll-grid__label" }
const _hoisted_44 = { class: "wage-payroll-grid__input wage-payroll-grid__input--readonly" }
const _hoisted_45 = {
  key: 1,
  class: "wage-lunch-warning"
}
const _hoisted_46 = { class: "wage-nontax-options" }
const _hoisted_47 = ["checked", "disabled"]
const _hoisted_48 = ["checked", "disabled"]
const _hoisted_49 = {
  key: 0,
  class: "wage-detail-card__footer"
}
const _hoisted_50 = { class: "wage-card-total" }
const _hoisted_51 = { style: {"white-space":"pre-line"} }
const _hoisted_52 = { class: "wage-card-total__value" }
const _hoisted_53 = { class: "wage-detail-card wage-detail-card--taxable-other" }
const _hoisted_54 = { class: "wage-detail-card__body wage-detail-card__body--stretch" }
const _hoisted_55 = { class: "wage-detail-card__content" }
const _hoisted_56 = { class: "wage-payroll-grid" }
const _hoisted_57 = ["for"]
const _hoisted_58 = ["id", "value", "disabled", "onInput"]
const _hoisted_59 = { class: "wage-detail-card__footer" }
const _hoisted_60 = { class: "wage-card-total" }
const _hoisted_61 = { class: "wage-card-total__value" }
const _hoisted_62 = { class: "detail-wage-board__row detail-wage-board__row--deduct" }
const _hoisted_63 = { class: "wage-detail-card wage-detail-card--socialInsurance" }
const _hoisted_64 = { class: "wage-detail-card__head" }
const _hoisted_65 = { class: "wage-detail-card__head-text" }
const _hoisted_66 = { class: "wage-detail-card__title wage-detail-card__title--with-help" }
const _hoisted_67 = { style: {"white-space":"pre-line"} }
const _hoisted_68 = { class: "wage-detail-card__body wage-detail-card__body--stretch" }
const _hoisted_69 = { class: "wage-detail-card__content" }
const _hoisted_70 = { class: "wage-insurance-single" }
const _hoisted_71 = { style: {"white-space":"pre-line"} }
const _hoisted_72 = ["checked", "disabled", "onChange"]
const _hoisted_73 = { style: {"white-space":"pre-line"} }
const _hoisted_74 = ["value", "disabled", "readonly", "onClick", "onInput", "onBlur"]
const _hoisted_75 = { style: {"white-space":"pre-line"} }
const _hoisted_76 = ["checked", "disabled", "onChange"]
const _hoisted_77 = { style: {"white-space":"pre-line"} }
const _hoisted_78 = ["value", "disabled", "readonly", "onClick", "onInput", "onBlur"]
const _hoisted_79 = { class: "wage-detail-card wage-detail-card--laborDeduct" }
const _hoisted_80 = { class: "wage-detail-card__head" }
const _hoisted_81 = { class: "wage-detail-card__head-text" }
const _hoisted_82 = { class: "wage-detail-card__title wage-detail-card__title--with-help" }
const _hoisted_83 = { style: {"white-space":"pre-line"} }
const _hoisted_84 = { class: "wage-detail-card__body wage-detail-card__body--stretch" }
const _hoisted_85 = { class: "wage-detail-card__content" }
const _hoisted_86 = { class: "wage-insurance-single" }
const _hoisted_87 = { class: "wage-insurance-single__name" }
const _hoisted_88 = {
  key: 0,
  class: "wage-insurance-single__fix-cb-slot wage-insurance-single__fix-cb-slot--empty",
  "aria-hidden": "true"
}
const _hoisted_89 = ["checked", "disabled", "onChange"]
const _hoisted_90 = { style: {"white-space":"pre-line"} }
const _hoisted_91 = ["value", "disabled", "readonly", "onClick", "onInput", "onBlur"]
const _hoisted_92 = { class: "wage-detail-card__footer" }
const _hoisted_93 = { class: "wage-card-total wage-card-total--grand" }
const _hoisted_94 = { class: "wage-card-total__value" }
const _hoisted_95 = { class: "wage-detail-card wage-detail-card--corpDeduct" }
const _hoisted_96 = { class: "wage-detail-card__head" }
const _hoisted_97 = { class: "wage-detail-card__head-text" }
const _hoisted_98 = { class: "wage-detail-card__title wage-detail-card__title--with-help" }
const _hoisted_99 = { style: {"white-space":"pre-line"} }
const _hoisted_100 = { class: "wage-detail-card__body wage-detail-card__body--stretch" }
const _hoisted_101 = { class: "wage-detail-card__content" }
const _hoisted_102 = { class: "wage-insurance-single wage-insurance-single--corp-deduct" }
const _hoisted_103 = { class: "wage-insurance-single__name" }
const _hoisted_104 = ["checked", "disabled", "onChange"]
const _hoisted_105 = { style: {"white-space":"pre-line"} }
const _hoisted_106 = ["value", "disabled", "readonly", "onClick", "onInput", "onBlur"]
const _hoisted_107 = { class: "wage-representative-row" }
const _hoisted_108 = ["checked", "disabled"]
const _hoisted_109 = { class: "wage-detail-card__footer" }
const _hoisted_110 = { class: "wage-card-total wage-card-total--grand" }
const _hoisted_111 = { class: "wage-card-total__value" }
const _hoisted_112 = { class: "wage-reference-bar-wrap" }
const _hoisted_113 = { class: "wage-reference-bar" }
const _hoisted_114 = { class: "wage-reference-bar__items" }
const _hoisted_115 = { style: {"white-space":"pre-line"} }
const _hoisted_116 = { class: "wage-reference-bar__value" }

import { computed } from 'vue';
import HomeWageTooltip from '@/components/wage/home/HomeWageTooltip.vue';
import { formatWageNumber, parseWageNumber, sanitizeHoursInput, parseHours } from '@/composables/wage/useWageCalculator';
import type { CommonWageCalcResult, CommonWageManualFlags } from '@/composables/wage/useCommonWageCalc';
import type { CommonWageFormStrings } from '@/utils/commonWageMapper';
import type { CcwdFormInputField } from '@/constants/commonWageFields';
import type { CommonWagePayrollFieldDef } from '@/policies/commonWagePayrollFields';
import {
  COMMON_WAGE_WORK_INFO_FIELDS,
  COMMON_WAGE_NON_TAX_INPUT_FIELDS,
  COMMON_WAGE_PREMIUM_NONTAX_FIELDS,
  COMMON_WAGE_TAXABLE_OTHER_FIELDS,
  COMMON_WAGE_INSURANCE_SHARED,
  COMMON_WAGE_EMPLOYMENT_INSURANCE,
  COMMON_WAGE_LABOR_OTHER_FIELDS,
  COMMON_WAGE_CORP_OTHER_FIELDS,
  COMMON_WAGE_REFERENCE_FIELDS,
  COMMON_WAGE_INSURANCE_FIX_TOOLTIP,
  COMMON_WAGE_USER_HELP_WORK_CALC,
  COMMON_WAGE_ADMIN_HELP_BASIC_CALC_MODE,
  COMMON_WAGE_USER_HELP_MANUAL_CHECKBOX,
} from '@/policies/commonWagePayrollFields';


export default /*@__PURE__*/_defineComponent({
  __name: 'CommonWageDetailBoard',
  props: {
    form: {},
    displayCalc: {},
    deductForm: {},
    manualFlags: {},
    productionNontax: { type: Boolean },
    lunchExpense: { type: Boolean },
    showProductionWorkerOption: { type: Boolean },
    productionNontaxAllowed: { type: Boolean },
    minHourlyWage: {},
    year: {},
    disabled: { type: Boolean },
    pensionExempt: { type: Boolean },
    employmentExempt: { type: Boolean },
    isOwner: { type: Boolean },
    lunchInvalid: { type: Boolean },
    lunchWarning: {},
    basicCalcMode: {},
    basicCalcModeAllowed: { type: Boolean }
  },
  emits: ["amount-input", "hours-input", "hours-blur", "hourly-blur", "toggle-manual", "open-manual", "deduct-input", "deduct-blur", "calc-amount-input", "calc-amount-blur", "update:productionNontax", "update:lunchExpense", "update:isOwner", "update:basicCalcMode"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const workInfoFields = COMMON_WAGE_WORK_INFO_FIELDS;
const nonTaxInputFields = COMMON_WAGE_NON_TAX_INPUT_FIELDS;
const premiumNontaxFields = COMMON_WAGE_PREMIUM_NONTAX_FIELDS;
const taxableOtherFields = COMMON_WAGE_TAXABLE_OTHER_FIELDS;
const insuranceShared = COMMON_WAGE_INSURANCE_SHARED;
const employmentInsurance = COMMON_WAGE_EMPLOYMENT_INSURANCE;
const laborOtherFields = COMMON_WAGE_LABOR_OTHER_FIELDS;
const corpOtherFields = COMMON_WAGE_CORP_OTHER_FIELDS;
const referenceFields = COMMON_WAGE_REFERENCE_FIELDS;
const insuranceFixTooltip = COMMON_WAGE_INSURANCE_FIX_TOOLTIP;
const workCalcHelp = COMMON_WAGE_USER_HELP_WORK_CALC;
const adminBasicCalcHelp = COMMON_WAGE_ADMIN_HELP_BASIC_CALC_MODE;
const workCalcHelpText = computed(() =>
  basicCalcModeAllowed.value ? `${workCalcHelp}\n\n${adminBasicCalcHelp}` : workCalcHelp
);
const manualCheckboxHelp = COMMON_WAGE_USER_HELP_MANUAL_CHECKBOX;

const basicCalcMode = computed(() => props.basicCalcMode || 'hourly');
const basicCalcModeAllowed = computed(() => props.basicCalcModeAllowed === true);

const emitAmountInput = (field: CcwdFormInputField, event: Event) => {
  emit('amount-input', field, (event.target as HTMLInputElement).value);
};

const emitHoursInput = (field: CcwdFormInputField, event: Event) => {
  const target = event.target as HTMLInputElement;
  let cleaned: string;
  if (field === 'cwhd_work_days') {
    cleaned = target.value.replace(/[^\d]/g, '');
    const num = parseInt(cleaned, 10) || 0;
    if (num > 31) cleaned = '31';
  } else {
    cleaned = sanitizeHoursInput(target.value);
    const num = parseHours(cleaned);
    if (num >= 1000) cleaned = '999.9';
  }
  if (cleaned !== target.value) {
    target.value = cleaned;
  }
  emit('hours-input', field, cleaned);
};

const emitHoursBlur = (field: CcwdFormInputField) => {
  emit('hours-blur', field);
};

const emitCalcAmountInput = (key: string, event: Event) => {
  emit('calc-amount-input', key, (event.target as HTMLInputElement).value);
};

const emitCalcAmountBlur = (key: string, event: Event) => {
  emit('calc-amount-blur', key, event);
};

const requestManualToggle = (field: keyof CommonWageManualFlags, event: Event) => {
  if (props.disabled) return;
  const checked = (event.target as HTMLInputElement).checked;
  emit('toggle-manual', field, checked);
};

const isManualLocked = (field: keyof CommonWageManualFlags) => !!props.manualFlags[field];

const onManualFieldActivate = (field: keyof CommonWageManualFlags) => {
  if (props.disabled || !isManualLocked(field)) return;
  emit('open-manual', field);
};

const onLaborFieldActivate = (field: CommonWagePayrollFieldDef) => {
  if (field.manualOnly) return;
  onManualFieldActivate(getManualFlagKey(field.key));
};

const onProductionNontaxChange = (event: Event) => {
  if (props.disabled) return;
  const el = event.target as HTMLInputElement;
  const checked = el.checked;
  if (checked && !props.productionNontaxAllowed) {
    alert('생산직 비과세 적용 조건(직종·통상임금)을 충족하지 않습니다.');
    el.checked = false;
    return;
  }
  emit('update:productionNontax', checked);
};

const onLunchExpenseChange = (event: Event) => {
  if (props.disabled) return;
  emit('update:lunchExpense', (event.target as HTMLInputElement).checked);
};

const onIsOwnerChange = (event: Event) => {
  if (props.disabled) return;
  emit('update:isOwner', (event.target as HTMLInputElement).checked);
};

const showProductionNontax = computed(() => props.productionNontax);
const productionNontax = computed(() => props.productionNontax);
const lunchExpense = computed(() => props.lunchExpense);
const isOwner = computed(() => !!props.isOwner);
const hasPremiumNontax = computed(() =>
  premiumNontaxFields.some((f) => Number((props.displayCalc as Record<string, number>)[f.key]) > 0)
);

const parseFormMoney = (key: string) =>
  parseWageNumber(String(props.form[key as keyof CommonWageFormStrings] || ''));

const workInfoTotal = computed(() =>
  ['cwhd_basic', 'cwhd_overtime', 'cwhd_night', 'cwhd_holiday'].reduce(
    (sum, k) => sum + (Number((props.displayCalc as Record<string, number>)[k]) || 0),
    0
  )
);

/** 비과세액 합계 — 입력한 중식·차량·양육(+생산직 연야휴). 실비변상 채움(한도) 금액 미포함 */
const nonTaxTotal = computed(() => {
  let total = 0;
  for (const f of nonTaxInputFields) {
    total += parseFormMoney(f.key);
  }
  if (props.productionNontax) {
    total += premiumNontaxFields.reduce(
      (sum, f) => sum + (Number((props.displayCalc as Record<string, number>)[f.key]) || 0),
      0
    );
  }
  return total;
});

const taxableOtherTotal = computed(() =>
  taxableOtherFields.reduce((sum, f) => sum + parseFormMoney(f.key), 0)
);

const employmentSides = [
  { role: 'labor', chipLabel: '근로', key: COMMON_WAGE_EMPLOYMENT_INSURANCE.laborKey, manualKey: 'l_go' as const },
  { role: 'corp', chipLabel: '기관', key: COMMON_WAGE_EMPLOYMENT_INSURANCE.corpKey, manualKey: 'c_go' as const },
] as const;

function fieldHoursId(field: CommonWagePayrollFieldDef) {
  return field.hoursKey ? `cw-hours-${field.hoursKey}` : `cw-${field.key}`;
}

function formatCalcMoney(key: string) {
  return formatWageNumber(Number((props.displayCalc as Record<string, number>)[key]) || 0);
}

/** 공제 — 수동값 우선, 없으면 자동계산값 표시 (항상 입력 가능) */
function formatDeductOrCalc(laborKey: string, manualFlag: keyof CommonWageManualFlags) {
  if (props.manualFlags[manualFlag]) {
    return formatDeductMoney(laborKey);
  }
  return formatCalcMoney(laborKey);
}

function formatDeductMoney(key: string) {
  const val = props.deductForm[key];
  return val != null && val !== 0 ? formatWageNumber(val) : '';
}

function formatReferenceValue(key: string) {
  if (key === 'netPay') return formatCalcMoney('netPay');
  return formatCalcMoney(key);
}

function getManualFlagKey(deductKey: string): keyof CommonWageManualFlags {
  const map: Record<string, keyof CommonWageManualFlags> = {
    cwhd_l_so: 'l_so',
    cwhd_l_ji: 'l_ji',
    cwhd_l_jiwon: 'l_jiwon',
    cwhd_l_sik: 'l_sik',
    cwhd_l_etc: 'l_etc',
    cwhd_l_yearend: 'l_yearend',
    cwhd_c_sil: 'c_sil',
    cwhd_c_san: 'c_san',
    cwhd_c_out: 'c_out',
  };
  return map[deductKey] || 'l_etc';
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("section", _hoisted_3, [
        _createElementVNode("header", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h3", _hoisted_6, [
              _cache[9] || (_cache[9] = _createElementVNode("span", null, "근무정보", -1)),
              _createVNode(HomeWageTooltip, {
                location: "top",
                "member-visible": ""
              }, {
                activator: _withCtx(({ props: tip }) => [
                  _createVNode(_component_v_icon, _mergeProps(tip, {
                    size: "14",
                    class: "wage-user-help-icon"
                  }), {
                    default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                      _createTextVNode("mdi-help-circle-outline", -1)
                    ]))]),
                    _: 1
                  }, 16)
                ]),
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_7, _toDisplayString(workCalcHelpText.value), 1)
                ]),
                _: 1
              })
            ])
          ]),
          (basicCalcModeAllowed.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass(["wage-basic-calc-mode__btn", { 'wage-basic-calc-mode__btn--active': basicCalcMode.value === 'hourly' }]),
                    disabled: __props.disabled,
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('update:basicCalcMode', 'hourly')))
                  }, "시급×시간", 10, _hoisted_10),
                  _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass(["wage-basic-calc-mode__btn", { 'wage-basic-calc-mode__btn--active': basicCalcMode.value === 'basic' }]),
                    disabled: __props.disabled,
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('update:basicCalcMode', 'basic')))
                  }, "기본급→시간", 10, _hoisted_11)
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createVNode(HomeWageTooltip, { location: "top" }, {
                activator: _withCtx(({ props: tooltipProps }) => [
                  _createElementVNode("label", _mergeProps(tooltipProps, {
                    class: "wage-payroll-grid__label wage-payroll-grid__label--tooltip",
                    for: "cw-hourly-wage"
                  }), "시급", 16)
                ]),
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_15, "시간당 임금 (기본: 최저시급)" + _toDisplayString(__props.minHourlyWage ? `\n현재: ${_unref(formatWageNumber)(parseFormMoney('cwhd_pay_calc_hourly'))}원` : ''), 1)
                ]),
                _: 1
              }),
              _createElementVNode("input", {
                id: "cw-hourly-wage",
                value: __props.form.cwhd_pay_calc_hourly,
                type: "text",
                class: "wage-payroll-grid__input",
                placeholder: "0",
                inputmode: "numeric",
                disabled: __props.disabled,
                onInput: _cache[2] || (_cache[2] = ($event: any) => (emitAmountInput('cwhd_pay_calc_hourly', $event))),
                onBlur: _cache[3] || (_cache[3] = ($event: any) => (emit('hourly-blur')))
              }, null, 40, _hoisted_16),
              _createVNode(HomeWageTooltip, { location: "top" }, {
                activator: _withCtx(({ props: tooltipProps }) => [
                  _createElementVNode("label", _mergeProps(tooltipProps, {
                    class: "wage-payroll-grid__label wage-payroll-grid__label--tooltip",
                    for: "cw-work-hours"
                  }), "근무시간", 16)
                ]),
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_17, _toDisplayString(basicCalcMode.value === 'basic' ? '기본급 ÷ 시급으로 자동 산출됩니다.' : `월 총 근무 시간${__props.form.cwhd_work_hours ? `\n현재: ${__props.form.cwhd_work_hours}시간` : ''}`), 1)
                ]),
                _: 1
              }),
              _createElementVNode("input", {
                id: "cw-work-hours",
                value: __props.form.cwhd_work_hours,
                type: "text",
                class: _normalizeClass(["wage-payroll-grid__input", { 'wage-payroll-grid__input--readonly': basicCalcMode.value === 'basic' }]),
                inputmode: "decimal",
                disabled: __props.disabled || basicCalcMode.value === 'basic',
                onInput: _cache[4] || (_cache[4] = ($event: any) => (emitHoursInput('cwhd_work_hours', $event))),
                onBlur: _cache[5] || (_cache[5] = ($event: any) => (emitHoursBlur('cwhd_work_hours')))
              }, null, 42, _hoisted_18)
            ]),
            _createElementVNode("div", _hoisted_19, [
              _cache[10] || (_cache[10] = _createElementVNode("label", {
                class: "wage-payroll-grid__label",
                for: "cw-work-days"
              }, "근무일수", -1)),
              _createElementVNode("input", {
                id: "cw-work-days",
                value: __props.form.cwhd_work_days,
                type: "text",
                class: "wage-payroll-grid__input",
                inputmode: "decimal",
                placeholder: "근무일",
                disabled: __props.disabled,
                onInput: _cache[6] || (_cache[6] = ($event: any) => (emitHoursInput('cwhd_work_days', $event))),
                onBlur: _cache[7] || (_cache[7] = ($event: any) => (emitHoursBlur('cwhd_work_days')))
              }, null, 40, _hoisted_20),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(workInfoFields), (field) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: field.key
                }, [
                  (field.tooltip)
                    ? (_openBlock(), _createBlock(HomeWageTooltip, {
                        key: 0,
                        location: "top"
                      }, {
                        activator: _withCtx(({ props: tooltipProps }) => [
                          _createElementVNode("label", _mergeProps({ ref_for: true }, tooltipProps, {
                            class: "wage-payroll-grid__label wage-payroll-grid__label--tooltip",
                            for: fieldHoursId(field)
                          }), _toDisplayString(field.label), 17, _hoisted_21)
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_22, _toDisplayString(field.tooltip), 1)
                        ]),
                        _: 2
                      }, 1024))
                    : (_openBlock(), _createElementBlock("label", {
                        key: 1,
                        class: "wage-payroll-grid__label",
                        for: fieldHoursId(field)
                      }, _toDisplayString(field.label), 9, _hoisted_23)),
                  (field.premiumHours && field.hoursKey)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                        _createElementVNode("input", {
                          id: fieldHoursId(field),
                          value: __props.form[field.hoursKey],
                          type: "text",
                          class: "wage-payroll-premium__hours",
                          placeholder: "시간",
                          inputmode: "decimal",
                          disabled: __props.disabled,
                          onInput: ($event: any) => (emitHoursInput(field.hoursKey!, $event)),
                          onBlur: ($event: any) => (emitHoursBlur(field.hoursKey!))
                        }, null, 40, _hoisted_25),
                        _createElementVNode("span", {
                          class: "wage-payroll-premium__amount wage-payroll-premium__amount--readonly",
                          title: `${field.label} (시간×시급 자동계산)`
                        }, _toDisplayString(formatCalcMoney(field.key)), 9, _hoisted_26)
                      ]))
                    : (field.key === 'cwhd_basic')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                          (basicCalcMode.value === 'basic')
                            ? (_openBlock(), _createElementBlock("input", {
                                key: 0,
                                id: `cw-${field.key}`,
                                type: "text",
                                class: "wage-payroll-grid__input",
                                value: formatCalcMoney(field.key),
                                inputmode: "numeric",
                                disabled: __props.disabled,
                                onInput: ($event: any) => (emitCalcAmountInput(field.key, $event)),
                                onBlur: ($event: any) => (emitCalcAmountBlur(field.key, $event))
                              }, null, 40, _hoisted_27))
                            : (_openBlock(), _createElementBlock("span", {
                                key: 1,
                                class: "wage-payroll-grid__input wage-payroll-grid__input--readonly",
                                title: field.tooltip
                              }, _toDisplayString(formatCalcMoney(field.key)), 9, _hoisted_28))
                        ], 64))
                      : (field.readonly)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(formatCalcMoney(field.key)), 1))
                        : (_openBlock(), _createElementBlock("input", {
                            key: 5,
                            type: "text",
                            class: "wage-payroll-grid__input",
                            value: formatCalcMoney(field.key),
                            inputmode: "numeric",
                            disabled: __props.disabled,
                            onInput: ($event: any) => (emitCalcAmountInput(field.key, $event)),
                            onBlur: ($event: any) => (emitCalcAmountBlur(field.key, $event))
                          }, null, 40, _hoisted_30))
                ], 64))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, [
              _cache[11] || (_cache[11] = _createElementVNode("label", { class: "wage-card-total__label" }, "근무정보 합계", -1)),
              _createElementVNode("span", _hoisted_33, _toDisplayString(_unref(formatWageNumber)(workInfoTotal.value)), 1)
            ])
          ])
        ])
      ]),
      _createElementVNode("section", _hoisted_34, [
        _cache[17] || (_cache[17] = _createElementVNode("header", { class: "wage-detail-card__head" }, [
          _createElementVNode("div", { class: "wage-detail-card__head-text" }, [
            _createElementVNode("h3", { class: "wage-detail-card__title" }, "비과세 수당")
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_35, [
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("div", _hoisted_37, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(nonTaxInputFields), (field) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: field.key
                }, [
                  (field.tooltip)
                    ? (_openBlock(), _createBlock(HomeWageTooltip, {
                        key: 0,
                        location: "top"
                      }, {
                        activator: _withCtx(({ props: tooltipProps }) => [
                          _createElementVNode("label", _mergeProps({ ref_for: true }, tooltipProps, {
                            class: "wage-payroll-grid__label wage-payroll-grid__label--tooltip",
                            for: `cw-${field.key}`
                          }), _toDisplayString(field.label), 17, _hoisted_38)
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_39, _toDisplayString(field.tooltip), 1)
                        ]),
                        _: 2
                      }, 1024))
                    : (_openBlock(), _createElementBlock("label", {
                        key: 1,
                        class: "wage-payroll-grid__label",
                        for: `cw-${field.key}`
                      }, _toDisplayString(field.label), 9, _hoisted_40)),
                  _createElementVNode("input", {
                    id: `cw-${field.key}`,
                    value: __props.form[field.key as keyof CommonWageFormStrings],
                    type: "text",
                    class: _normalizeClass(["wage-payroll-grid__input", { 'wage-payroll-grid__input--error': field.key === 'cwhd_lunch' && __props.lunchInvalid }]),
                    inputmode: "numeric",
                    disabled: __props.disabled,
                    onInput: ($event: any) => (emitAmountInput(field.key as CcwdFormInputField, $event))
                  }, null, 42, _hoisted_41)
                ], 64))
              }), 128))
            ]),
            (showProductionNontax.value && hasPremiumNontax.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(premiumNontaxFields), (field) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: field.key
                    }, [
                      _createElementVNode("label", _hoisted_43, _toDisplayString(field.label), 1),
                      _createElementVNode("span", _hoisted_44, _toDisplayString(formatCalcMoney(field.key)), 1)
                    ], 64))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (__props.lunchWarning)
              ? (_openBlock(), _createElementBlock("div", _hoisted_45, _toDisplayString(__props.lunchWarning), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_46, [
              (__props.showProductionWorkerOption)
                ? (_openBlock(), _createBlock(HomeWageTooltip, {
                    key: 0,
                    location: "top",
                    text: "연장·야간·휴일수당의 비과세 한도 월 20만원 적용 (생산직 근로자)"
                  }, {
                    activator: _withCtx(({ props: tooltipProps }) => [
                      _createElementVNode("label", _mergeProps(tooltipProps, { class: "wage-nontax-options__item wage-nontax-options__item--tooltip" }), [
                        _createElementVNode("input", {
                          type: "checkbox",
                          class: "wage-nontax-options__checkbox",
                          checked: productionNontax.value,
                          disabled: __props.disabled,
                          onChange: onProductionNontaxChange
                        }, null, 40, _hoisted_47),
                        _cache[12] || (_cache[12] = _createElementVNode("span", { class: "wage-nontax-options__text" }, "생산직 비과세", -1)),
                        _cache[13] || (_cache[13] = _createElementVNode("span", { class: "wage-nontax-options__hint" }, "(연야휴 월20만)", -1))
                      ], 16)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(HomeWageTooltip, {
                location: "top",
                "member-visible": ""
              }, {
                activator: _withCtx(({ props: tooltipProps }) => [
                  _createElementVNode("label", _mergeProps(tooltipProps, { class: "wage-nontax-options__item wage-nontax-options__item--tooltip" }), [
                    _createElementVNode("input", {
                      type: "checkbox",
                      class: "wage-nontax-options__checkbox",
                      checked: lunchExpense.value,
                      disabled: __props.disabled,
                      onChange: onLunchExpenseChange
                    }, null, 40, _hoisted_48),
                    _cache[14] || (_cache[14] = _createElementVNode("span", { class: "wage-nontax-options__text" }, "중식비 실비변상", -1)),
                    _cache[15] || (_cache[15] = _createElementVNode("span", { class: "wage-nontax-options__hint" }, "(회계반영)", -1))
                  ], 16)
                ]),
                default: _withCtx(() => [
                  _cache[16] || (_cache[16] = _createElementVNode("span", { style: {"white-space":"pre-line"} }, "체크함: 기본급·수당·중식·과세 등 지급/과세 표시는 그대로 두고, 중식 한도 채움 후 과세 기준으로 4대보험·공제를 다시 계산합니다. 퇴직금은 총 지급금액에서 한도까지 채운 중식비를 빼고 12로 나눕니다. 체크 안 함: 입력한 중식비 기준으로 과세·공제를 계산합니다. 퇴직금은 총 지급금액 ÷ 12입니다.", -1))
                ]),
                _: 1
              })
            ])
          ]),
          (nonTaxTotal.value > 0 || showProductionNontax.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                _createElementVNode("div", _hoisted_50, [
                  _createVNode(HomeWageTooltip, { location: "top" }, {
                    activator: _withCtx(({ props: tooltipProps }) => [
                      _createElementVNode("label", _mergeProps(tooltipProps, { class: "wage-card-total__label wage-card-total__label--tooltip" }), "비과세액 합계", 16)
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_51, "입력한 중식비 + 차량보조비 + 양육비" + _toDisplayString(showProductionNontax.value ? ' + 연야휴 비과세' : '') + " (중식비 실비변상 체크 시에도 한도 채움 금액이 아닌 입력 중식비 기준)", 1)
                    ]),
                    _: 1
                  }),
                  _createElementVNode("span", _hoisted_52, _toDisplayString(_unref(formatWageNumber)(nonTaxTotal.value)), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("section", _hoisted_53, [
        _cache[19] || (_cache[19] = _createElementVNode("header", { class: "wage-detail-card__head" }, [
          _createElementVNode("div", { class: "wage-detail-card__head-text" }, [
            _createElementVNode("h3", { class: "wage-detail-card__title" }, "과세 수당")
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_54, [
          _createElementVNode("div", _hoisted_55, [
            _createElementVNode("div", _hoisted_56, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(taxableOtherFields), (field) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: field.key
                }, [
                  _createElementVNode("label", {
                    class: "wage-payroll-grid__label",
                    for: `cw-${field.key}`
                  }, _toDisplayString(field.label), 9, _hoisted_57),
                  _createElementVNode("input", {
                    id: `cw-${field.key}`,
                    value: __props.form[field.key as keyof CommonWageFormStrings],
                    type: "text",
                    class: "wage-payroll-grid__input",
                    inputmode: "numeric",
                    disabled: __props.disabled,
                    onInput: ($event: any) => (emitAmountInput(field.key as CcwdFormInputField, $event))
                  }, null, 40, _hoisted_58)
                ], 64))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_59, [
            _createElementVNode("div", _hoisted_60, [
              _cache[18] || (_cache[18] = _createElementVNode("label", { class: "wage-card-total__label" }, "과세 수당 합계", -1)),
              _createElementVNode("span", _hoisted_61, _toDisplayString(_unref(formatWageNumber)(taxableOtherTotal.value)), 1)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_62, [
      _createElementVNode("section", _hoisted_63, [
        _createElementVNode("header", _hoisted_64, [
          _createElementVNode("div", _hoisted_65, [
            _createElementVNode("h3", _hoisted_66, [
              _cache[21] || (_cache[21] = _createElementVNode("span", null, "4대보험", -1)),
              _createVNode(HomeWageTooltip, {
                location: "top",
                "member-visible": ""
              }, {
                activator: _withCtx(({ props: tip }) => [
                  _createVNode(_component_v_icon, _mergeProps(tip, {
                    size: "14",
                    class: "wage-user-help-icon"
                  }), {
                    default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                      _createTextVNode("mdi-help-circle-outline", -1)
                    ]))]),
                    _: 1
                  }, 16)
                ]),
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_67, _toDisplayString(_unref(manualCheckboxHelp)), 1)
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_68, [
          _createElementVNode("div", _hoisted_69, [
            _createElementVNode("div", _hoisted_70, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(insuranceShared), (pair) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: pair.key,
                  class: "wage-insurance-single__row"
                }, [
                  _createVNode(HomeWageTooltip, { location: "top" }, {
                    activator: _withCtx(({ props: tooltipProps }) => [
                      _createElementVNode("span", _mergeProps({ ref_for: true }, tooltipProps, { class: "wage-insurance-single__name wage-insurance-single__name--tooltip wage-insurance-single__name-with-chip" }), [
                        _createElementVNode("span", null, _toDisplayString(pair.label), 1),
                        _cache[22] || (_cache[22] = _createElementVNode("span", {
                          class: "wage-insurance-single__role-chip wage-insurance-single__role-chip--placeholder",
                          "aria-hidden": "true"
                        }, "근로", -1))
                      ], 16)
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_71, _toDisplayString(pair.tooltip), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(HomeWageTooltip, {
                    location: "top",
                    "member-visible": ""
                  }, {
                    activator: _withCtx(({ props: cbTip }) => [
                      _createElementVNode("span", _mergeProps({ ref_for: true }, cbTip, { class: "wage-insurance-single__fix-cb-slot" }), [
                        _createElementVNode("input", {
                          type: "checkbox",
                          class: "wage-insurance-single__fix-cb wage-insurance-single__fix-cb--tooltip",
                          checked: !!__props.manualFlags[pair.key as keyof CommonWageManualFlags],
                          disabled: __props.disabled,
                          onChange: ($event: any) => (requestManualToggle(pair.key as keyof CommonWageManualFlags, $event))
                        }, null, 40, _hoisted_72)
                      ], 16)
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_73, _toDisplayString(_unref(insuranceFixTooltip)), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createElementVNode("input", {
                    type: "text",
                    class: _normalizeClass(["wage-payroll-grid__input", { 'wage-payroll-grid__input--readonly': isManualLocked(pair.key) }]),
                    value: formatDeductOrCalc(pair.laborKey, pair.key as keyof CommonWageManualFlags),
                    inputmode: "numeric",
                    disabled: __props.disabled,
                    readonly: isManualLocked(pair.key),
                    onClick: _withModifiers(($event: any) => (onManualFieldActivate(pair.key, $event)), ["stop"]),
                    onInput: ($event: any) => (emit('deduct-input', pair.laborKey, $event)),
                    onBlur: ($event: any) => (emit('deduct-blur', pair.laborKey, $event))
                  }, null, 42, _hoisted_74)
                ]))
              }), 128)),
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(employmentSides, (side) => {
                return _createElementVNode("div", {
                  key: `go-${side.role}`,
                  class: "wage-insurance-single__row"
                }, [
                  _createVNode(HomeWageTooltip, { location: "top" }, {
                    activator: _withCtx(({ props: tooltipProps }) => [
                      _createElementVNode("span", _mergeProps({ ref_for: true }, tooltipProps, { class: "wage-insurance-single__name wage-insurance-single__name--tooltip wage-insurance-single__name-with-chip" }), [
                        _createElementVNode("span", null, _toDisplayString(_unref(employmentInsurance).label), 1),
                        _createElementVNode("span", {
                          class: _normalizeClass(["wage-insurance-single__role-chip", side.role === 'labor' ? 'wage-insurance-single__role-chip--labor' : 'wage-insurance-single__role-chip--corp'])
                        }, _toDisplayString(side.chipLabel), 3)
                      ], 16)
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_75, _toDisplayString(_unref(employmentInsurance).tooltip), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(HomeWageTooltip, {
                    location: "top",
                    "member-visible": ""
                  }, {
                    activator: _withCtx(({ props: cbTip }) => [
                      _createElementVNode("span", _mergeProps({ ref_for: true }, cbTip, { class: "wage-insurance-single__fix-cb-slot" }), [
                        _createElementVNode("input", {
                          type: "checkbox",
                          class: "wage-insurance-single__fix-cb wage-insurance-single__fix-cb--tooltip",
                          checked: !!(__props.manualFlags as Record<string, boolean>)[side.manualKey],
                          disabled: __props.disabled,
                          onChange: ($event: any) => (requestManualToggle(side.manualKey, $event))
                        }, null, 40, _hoisted_76)
                      ], 16)
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_77, _toDisplayString(_unref(insuranceFixTooltip)), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createElementVNode("input", {
                    type: "text",
                    class: _normalizeClass(["wage-payroll-grid__input", { 'wage-payroll-grid__input--readonly': isManualLocked(side.manualKey) }]),
                    value: formatDeductOrCalc(side.key, side.manualKey),
                    inputmode: "numeric",
                    disabled: __props.disabled,
                    readonly: isManualLocked(side.manualKey),
                    onClick: _withModifiers(($event: any) => (onManualFieldActivate(side.manualKey, $event)), ["stop"]),
                    onInput: ($event: any) => (emit('deduct-input', side.key, $event)),
                    onBlur: ($event: any) => (emit('deduct-blur', side.key, $event))
                  }, null, 42, _hoisted_78)
                ])
              }), 64))
            ])
          ]),
          _cache[23] || (_cache[23] = _createElementVNode("div", { class: "wage-detail-card__footer" }, [
            _createElementVNode("div", {
              class: "wage-detail-card__footer-spacer",
              "aria-hidden": "true"
            })
          ], -1))
        ])
      ]),
      _createElementVNode("section", _hoisted_79, [
        _createElementVNode("header", _hoisted_80, [
          _createElementVNode("div", _hoisted_81, [
            _createElementVNode("h3", _hoisted_82, [
              _cache[25] || (_cache[25] = _createElementVNode("span", null, "근로자공제", -1)),
              _createVNode(HomeWageTooltip, {
                location: "top",
                "member-visible": ""
              }, {
                activator: _withCtx(({ props: tip }) => [
                  _createVNode(_component_v_icon, _mergeProps(tip, {
                    size: "14",
                    class: "wage-user-help-icon"
                  }), {
                    default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                      _createTextVNode("mdi-help-circle-outline", -1)
                    ]))]),
                    _: 1
                  }, 16)
                ]),
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_83, _toDisplayString(_unref(manualCheckboxHelp)), 1)
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_84, [
          _createElementVNode("div", _hoisted_85, [
            _createElementVNode("div", _hoisted_86, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(laborOtherFields), (field) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: field.key,
                  class: "wage-insurance-single__row"
                }, [
                  _createElementVNode("span", _hoisted_87, _toDisplayString(field.label), 1),
                  (field.manualOnly)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_88))
                    : (_openBlock(), _createBlock(HomeWageTooltip, {
                        key: 1,
                        location: "top",
                        "member-visible": ""
                      }, {
                        activator: _withCtx(({ props: cbTip }) => [
                          _createElementVNode("span", _mergeProps({ ref_for: true }, cbTip, { class: "wage-insurance-single__fix-cb-slot" }), [
                            _createElementVNode("input", {
                              type: "checkbox",
                              class: "wage-insurance-single__fix-cb wage-insurance-single__fix-cb--tooltip",
                              checked: !!__props.manualFlags[getManualFlagKey(field.key)],
                              disabled: __props.disabled,
                              onChange: ($event: any) => (requestManualToggle(getManualFlagKey(field.key), $event))
                            }, null, 40, _hoisted_89)
                          ], 16)
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_90, _toDisplayString(_unref(insuranceFixTooltip)), 1)
                        ]),
                        _: 2
                      }, 1024)),
                  _createElementVNode("input", {
                    type: "text",
                    class: _normalizeClass(["wage-payroll-grid__input", { 'wage-payroll-grid__input--readonly': !field.manualOnly && isManualLocked(getManualFlagKey(field.key)) }]),
                    value: field.manualOnly ? formatDeductMoney(field.key) : formatDeductOrCalc(field.key, getManualFlagKey(field.key)),
                    inputmode: "numeric",
                    disabled: __props.disabled,
                    readonly: !field.manualOnly && isManualLocked(getManualFlagKey(field.key)),
                    onClick: _withModifiers(($event: any) => (onLaborFieldActivate(field, $event)), ["stop"]),
                    onInput: ($event: any) => (emit('deduct-input', field.key, $event)),
                    onBlur: ($event: any) => (emit('deduct-blur', field.key, $event))
                  }, null, 42, _hoisted_91)
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_92, [
            _createElementVNode("div", _hoisted_93, [
              _cache[26] || (_cache[26] = _createElementVNode("label", { class: "wage-card-total__label" }, "근로자공제합계", -1)),
              _createElementVNode("span", _hoisted_94, _toDisplayString(formatCalcMoney('cwhd_l_total')), 1)
            ])
          ])
        ])
      ]),
      _createElementVNode("section", _hoisted_95, [
        _createElementVNode("header", _hoisted_96, [
          _createElementVNode("div", _hoisted_97, [
            _createElementVNode("h3", _hoisted_98, [
              _cache[28] || (_cache[28] = _createElementVNode("span", null, "기관공제", -1)),
              _createVNode(HomeWageTooltip, {
                location: "top",
                "member-visible": ""
              }, {
                activator: _withCtx(({ props: tip }) => [
                  _createVNode(_component_v_icon, _mergeProps(tip, {
                    size: "14",
                    class: "wage-user-help-icon"
                  }), {
                    default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                      _createTextVNode("mdi-help-circle-outline", -1)
                    ]))]),
                    _: 1
                  }, 16)
                ]),
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_99, _toDisplayString(_unref(manualCheckboxHelp)), 1)
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_100, [
          _createElementVNode("div", _hoisted_101, [
            _createElementVNode("div", _hoisted_102, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(corpOtherFields), (field) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: field.key,
                  class: "wage-insurance-single__row"
                }, [
                  _createElementVNode("span", _hoisted_103, _toDisplayString(field.label), 1),
                  _createVNode(HomeWageTooltip, {
                    location: "top",
                    "member-visible": ""
                  }, {
                    activator: _withCtx(({ props: cbTip }) => [
                      _createElementVNode("span", _mergeProps({ ref_for: true }, cbTip, { class: "wage-insurance-single__fix-cb-slot" }), [
                        _createElementVNode("input", {
                          type: "checkbox",
                          class: "wage-insurance-single__fix-cb wage-insurance-single__fix-cb--tooltip",
                          checked: !!__props.manualFlags[getManualFlagKey(field.key)],
                          disabled: __props.disabled,
                          onChange: ($event: any) => (requestManualToggle(getManualFlagKey(field.key), $event))
                        }, null, 40, _hoisted_104)
                      ], 16)
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_105, _toDisplayString(_unref(insuranceFixTooltip)), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createElementVNode("input", {
                    type: "text",
                    class: _normalizeClass(["wage-payroll-grid__input", { 'wage-payroll-grid__input--readonly': isManualLocked(getManualFlagKey(field.key)) }]),
                    value: formatDeductOrCalc(field.key, getManualFlagKey(field.key)),
                    inputmode: "numeric",
                    disabled: __props.disabled,
                    readonly: isManualLocked(getManualFlagKey(field.key)),
                    onClick: _withModifiers(($event: any) => (onManualFieldActivate(getManualFlagKey(field.key), $event)), ["stop"]),
                    onInput: ($event: any) => (emit('deduct-input', field.key, $event)),
                    onBlur: ($event: any) => (emit('deduct-blur', field.key, $event))
                  }, null, 42, _hoisted_106)
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_107, [
              _createVNode(HomeWageTooltip, { location: "top" }, {
                activator: _withCtx(({ props: tooltipProps }) => [
                  _createElementVNode("label", _mergeProps(tooltipProps, { class: "wage-representative-row__label" }), [
                    _createElementVNode("input", {
                      type: "checkbox",
                      class: "wage-representative-row__cb",
                      checked: isOwner.value,
                      disabled: __props.disabled,
                      onChange: onIsOwnerChange
                    }, null, 40, _hoisted_108),
                    _cache[29] || (_cache[29] = _createElementVNode("span", null, "대표자", -1))
                  ], 16)
                ]),
                default: _withCtx(() => [
                  _cache[30] || (_cache[30] = _createElementVNode("span", { style: {"white-space":"pre-line"} }, "대표자: 고용·실업·산재보험, 퇴직금 미적용", -1))
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_109, [
            _createElementVNode("div", _hoisted_110, [
              _cache[31] || (_cache[31] = _createElementVNode("label", { class: "wage-card-total__label" }, "기관공제합계", -1)),
              _createElementVNode("span", _hoisted_111, _toDisplayString(formatCalcMoney('cwhd_c_total')), 1)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_112, [
      _cache[32] || (_cache[32] = _createElementVNode("p", { class: "wage-reference-bar-hint" }, "체크하면 금액 설정 창이 열립니다. 체크를 끄면 자동계산으로 돌아갑니다.", -1)),
      _createElementVNode("section", _hoisted_113, [
        _createElementVNode("div", _hoisted_114, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(referenceFields), (field) => {
            return (_openBlock(), _createElementBlock("div", {
              key: field.key,
              class: "wage-reference-bar__item"
            }, [
              _createVNode(HomeWageTooltip, { location: "top" }, {
                activator: _withCtx(({ props: tooltipProps }) => [
                  _createElementVNode("span", _mergeProps({ ref_for: true }, tooltipProps, { class: "wage-reference-bar__label wage-reference-bar__label--tooltip" }), _toDisplayString(field.label), 17)
                ]),
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_115, _toDisplayString(field.tooltip), 1)
                ]),
                _: 2
              }, 1024),
              _createElementVNode("span", _hoisted_116, _toDisplayString(formatReferenceValue(field.key)) + "원", 1)
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}
}

})